<template>
  <!-- 境外浏览地址管理 -->
  <div class="overseas page_padding">
    <div class="page_content" v-if="authority">
      <div class="head">
        <div class="topAn">
          <el-button type="primary" size="mini" plain @click="addWeb">
            <i class="el-icon-plus"></i>新增网站
          </el-button>
          <!-- 类别管理 -->
          <el-popover placement="right" width="400" trigger="click">
            <i class="el-icon-circle-plus" @click="addType"></i>
            <el-table :height="400" :data="typeData">
              <el-table-column
                width="100"
                property="kindName"
                label="类别名"
              ></el-table-column>
              <el-table-column align="right" label="操作">
                <template slot-scope="scope">
                  <i
                    class="el-icon-edit"
                    style="margin-right: 10px;"
                    @click="editType(scope.row)"
                  ></i>
                  <template>
                    <el-popconfirm
                      confirmButtonText="确定"
                      cancelButtonText="取消"
                      :hideIcon="true"
                      title="确定删除吗？"
                      @confirm="confirmDelType(scope.$index, scope.row)"
                    >
                      <i class="el-icon-delete" slot="reference"></i>
                    </el-popconfirm>
                  </template>
                </template>
              </el-table-column>
            </el-table>
            <span
              class="topAn btn"
              type="text"
              size="mini"
              plain
              slot="reference"
              >类别管理</span
            >
          </el-popover>
        </div>
        <!-- 筛选 -->
        <div class="screening_box topAn">
          <el-input
            v-model="name"
            placeholder="请输入网站名"
            clearable
            @change="search"
          ></el-input>
          <el-select
            v-model="kindId"
            filterable
            placeholder="请选择类别"
            @change="search"
          >
            <el-option
              :label="_type.kindName"
              :value="_type.id"
              v-for="(_type, _i) in screenTypeData"
              :key="_i"
              >{{ _type.kindName }}</el-option
            >
          </el-select>
        </div>
      </div>
      <!-- 网站列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column label="类型" width="130">
            <template slot-scope="scope">
              <p style="white-space: nowrap;">
                {{ allTypeObj[scope.row.kindId] }}
              </p>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="网站名"> </el-table-column>
          <el-table-column label="地址">
            <template slot-scope="scope">
              <p style="white-space: nowrap;">
                <a
                  :href="
                    'http://129.28.167.115:8085/visit/page?url=' + scope.row.url
                  "
                  target="_blank"
                  >{{ scope.row.url }}</a
                >
              </p>
            </template>
          </el-table-column>
          <el-table-column align="right" label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <template>
                <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  :hideIcon="true"
                  title="确定删除吗？"
                  @confirm="delWeb(scope.$index, scope.row)"
                >
                  <el-button slot="reference" size="mini" type="danger"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="paging_box">
        <span class="total">共{{ total }}条</span>
        <span class="perPage_num">本页{{ tableData.length }}条</span>
        <el-pagination
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="changePage"
        >
        </el-pagination>
      </div>

      <!-- 添加/编辑境外网站 -->
      <el-dialog
        :title="is_add ? '添加网站' : '编辑网站'"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="dialogFormVisible"
        @close="cancel"
      >
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <!-- 名称 -->
          <el-form-item label="网站名称" prop="name">
            <el-input
              v-model="ruleForm.name"
              placeholder="请输入网站名称"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 网站地址 -->
          <el-form-item label="网站地址" prop="url">
            <el-input
              v-model="ruleForm.url"
              placeholder="请输入网站地址"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 类别 -->
          <el-form-item label="类别" prop="kindId">
            <el-select
              v-model="ruleForm.kindId"
              filterable
              placeholder="请选择类别"
            >
              <el-option
                :label="_type.kindName"
                :value="_type.id"
                v-for="(_type, _i) in typeData"
                :key="_i"
                >{{ _type.kindName }}</el-option
              >
            </el-select>
          </el-form-item>
          <!-- 公司 -->
          <el-form-item label="公司" prop="companyId" v-if="isAdmin">
            <el-select
              v-model="ruleForm.companyId"
              filterable
              placeholder="请选择公司"
            >
              <el-option
                :label="_item.companyname"
                :value="_item.companyid"
                v-for="(_item, _i) in companyList"
                :key="_i"
                >{{ _item.companyname }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancel">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="submitForm"
            >{{ is_add ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>

      <!-- 添加/编辑类别 -->
      <el-dialog
        :title="is_addType ? '添加类别' : '编辑类别'"
        :top="dialog_top"
        :close-on-click-modal="false"
        :visible.sync="typeVisible"
        @close="cancelType"
      >
        <el-form :model="typeForm" :rules="rules" ref="typeForm">
          <!-- 类别名称 -->
          <el-form-item label="类别：" prop="kindName">
            <el-input
              v-model="typeForm.kindName"
              placeholder="请输入类别"
              clearable
            ></el-input>
          </el-form-item>
          <!-- 公司 -->
          <el-form-item label="公司" prop="companyId" v-if="isAdmin">
            <el-select
              v-model="typeForm.companyId"
              filterable
              placeholder="请选择公司"
            >
              <el-option
                :label="_item.companyname"
                :value="_item.companyid"
                v-for="(_item, _i) in companyList"
                :key="_i"
                >{{ _item.companyname }}</el-option
              >
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="cancelType">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            :loading="btnLoading"
            :disabled="btnLoading"
            @click="changeType"
            >{{ is_addType ? "确 定" : "保 存" }}</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="null_page" v-else>没有操作权限</div>
  </div>
</template>

<script>
import mixins from "../../../mixins";

export default {
  mixins: [mixins],
  data() {
    return {
      btnLoading: false,
      name: "",
      kindId: "",
      dialogFormVisible: false,
      is_add: true,
      // 表单
      ruleForm: {
        name: "",
        url: "",
        kindId: "",
        companyId: ""
      },
      // 表单检验规则
      rules: {
        name: [{ required: true, message: "请输入网站名称", trigger: "blur" }],
        url: [{ required: true, message: "请输入网站地址", trigger: "blur" }],
        kindId: [{ required: true, message: "请选择类别", trigger: "blur" }],
        // companyId: [
        //     { required: true, message: '请选择公司', trigger: 'blur' },
        // ],
        kindName: [{ required: true, message: "请输入类别", trigger: "blur" }]
      },
      dialog_top: "15vh",

      typeData: [],
      screenTypeData: [],
      allTypeObj: {},
      typeVisible: false,
      is_addType: true,
      typeForm: {
        kindName: "",
        companyId: ""
      },
      typeItem: {},
      webItem: {},
      companyList: []
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    companyId() {
      return this.$store.state.companyId;
    }
  },
  mounted() {
    this.getTypeList();
    this.getCompanyList();
  },
  methods: {
    // 获取网站列表
    getList() {
      if (!this.authority) return;
      this.loading = true;
      this.tableScrollTop();
      this.$http({
        url: this.$api.web_list,
        data: {
          name: this.name,
          kind: this.kindId,
          companyId: this.companyId,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.concent;
        }
      });
    },
    // 获取类别列表
    getTypeList() {
      if (!this.authority) return;
      this.$http({
        url: this.$api.type_list,
        data: {
          companyId: this.companyId
        }
      }).then(res => {
        if (res.code == 0) {
          this.typeData = res.data;
          this.screenTypeData = JSON.parse(JSON.stringify(res.data));
          this.screenTypeData.unshift({ kindName: "全部", id: "" });
          res.data.forEach(val => {
            this.allTypeObj[val.id] = val.kindName;
          });
        }
      });
    },
    // 删除网站
    delWeb(index, item) {
      this.$http({
        url: this.$api.del_web,
        data: {
          id: item.id
        }
      }).then(res => {
        if (res.code == 0) {
          this.tableData.splice(index, 1);
          this.total--;
          this.$hint("删除成功");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 增加网站
    addWeb() {
      this.dialogFormVisible = true;
      this.is_add = true;
      this.ruleForm = {
        name: "",
        url: "",
        kindId: "",
        companyId: ""
      };
    },
    // 编辑网站
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.is_add = false;
      this.ruleForm = {
        name: row.name,
        url: row.url,
        kindId: row.kindId,
        companyId: row.companyId
      };
      this.webItem = JSON.parse(JSON.stringify(row));
    },
    // 确定新增、编辑
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          let data = JSON.parse(JSON.stringify(this.ruleForm));
          if (!this.is_add) data.id = this.webItem.id;
          if (!this.isAdmin) data.companyId = this.companyId;
          this.$http({
            url: this.$api.edit_web,
            data
          }).then(res => {
            this.btnLoading = false;
            if (res.code == 0) {
              this.cancel();
              this.page = 1;
              this.getList();
              this.is_add ? this.$hint("添加成功") : this.$hint("保存成功");
            } else {
              this.$hint(res.message, "err");
            }
          });
        }
      });
    },
    // 点击取消
    cancel() {
      this.dialogFormVisible = false;
      this.$refs.ruleForm.resetFields();
    },
    // 点击取消
    cancelType() {
      this.typeVisible = false;
      this.$refs.typeForm.resetFields();
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList();
    },

    // 确认删除类别
    confirmDelType(index, item) {
      this.$http({
        url: this.$api.del_type,
        data: {
          id: item.id
        }
      }).then(res => {
        if (res.code == 0) {
          this.typeData.splice(index, 1);
          this.$hint("删除成功");
        } else {
          this.$hint(res.message, "err");
        }
      });
    },
    // 新增编辑类别
    changeType() {
      this.$refs.typeForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          let data = {
            kindName: this.typeForm.kindName,
            companyId: ""
          };
          !this.isAdmin
            ? (data.companyId = this.companyId)
            : (data.companyId = this.typeForm.companyId);
          if (!this.is_addType) data.id = this.typeItem.id;
          this.$http({
            url: this.$api.edit_type,
            data
          })
            .then(res => {
              this.btnLoading = false;
              if (res.code == 0) {
                this.cancelType();
                this.getTypeList();
                this.is_addType
                  ? this.$hint("添加成功")
                  : this.$hint("保存成功");
              } else {
                this.$hint(res.message, "err");
              }
            })
            .catch(err => {
              this.btnLoading = false;
            });
        }
      });
    },
    // 点击添加类别
    addType() {
      this.typeForm.kindName = "";
      this.typeForm.companyId = "";
      this.typeVisible = true;
      this.is_addType = true;
    },
    // 点击编辑类别
    editType(item) {
      this.typeItem = item;
      this.typeForm.kindName = item.kindName;
      this.typeForm.companyId = item.companyId;
      this.typeVisible = true;
      this.is_addType = false;
    },
    // 获取公司列表
    getCompanyList() {
      if (!this.isAdmin) return;
      this.$http({
        url: this.$api.company_list
      }).then(res => {
        if (res.code == 0) {
          this.companyList = JSON.parse(JSON.stringify(res.data));
          this.companyList.unshift({ companyid: "", companyname: "通用" });
        }
      });
    }
  }
};
</script>

<style></style>
<style lang="less" scoped>
.overseas {
  .head {
    padding-right: 0;
  }
  .btn {
    font-size: 13px;
    margin-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/views/overseas.vue